// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.verification

import org.multipaz.cbor.DataItem
import org.multipaz.verification.OpenID4VPPresentmentRecord
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr

fun OpenID4VPPresentmentRecord.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "xIojDrOW74eo8EFTVud-qmLdfw78WgeWK6-9hYK7eLY")
val OpenID4VPPresentmentRecord_cborSchemaId = ByteString(-60, -118, 35, 14, -77, -106, -17, -121, -88, -16, 65, 83, 86, -25, 126, -86, 98, -35, 127, 14, -4, 90, 7, -106, 43, -81, -67, -123, -126, -69, 120, -74)

fun OpenID4VPPresentmentRecord.Companion.fromCbor(data: ByteArray): OpenID4VPPresentmentRecord {
    return OpenID4VPPresentmentRecord.fromDataItem(Cbor.decode(data))
}

val OpenID4VPPresentmentRecord.Companion.cborSchemaId: ByteString
    get() = OpenID4VPPresentmentRecord_cborSchemaId

fun OpenID4VPPresentmentRecord.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "OpenID4VP")
    builder.put("vpToken", Tstr(this.vpToken))
    builder.put("vpRequest", Tstr(this.vpRequest))
    val mdocSessionTranscript = this.mdocSessionTranscript
    if (mdocSessionTranscript != null) {
        builder.put("mdocSessionTranscript", mdocSessionTranscript)
    }
    return builder.end().build()
}

fun OpenID4VPPresentmentRecord.Companion.fromDataItem(dataItem: DataItem): OpenID4VPPresentmentRecord {
    val vpToken = dataItem["vpToken"].asTstr
    val vpRequest = dataItem["vpRequest"].asTstr
    val mdocSessionTranscript0 = if (dataItem.hasKey("mdocSessionTranscript")) {
        dataItem["mdocSessionTranscript"]
    } else {
        null
    }
    return OpenID4VPPresentmentRecord(
        vpToken = vpToken,
        vpRequest = vpRequest,
        mdocSessionTranscript = mdocSessionTranscript0,
    )
}
